import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sv-apps',
  templateUrl: './sv-apps.component.html',
  styleUrls: ['./sv-apps.component.scss']
})
export class SvAppsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
